import { DOMAIN } from "../../services/apiRoutes";

export const FORGOT_PASSWORD_REDEIRECT_ROUTE = `${DOMAIN}/forgot-password`;
export const EMAIL_VERIFY_REDEIRECT_ROUTE = `${DOMAIN}/email-verify`;
